import { LOCATION_CHANGE, push } from 'react-router-redux';

// App Config
import appConfiguration from '../services/AppConfiguration';
import appRoutes from '../constants/appRoutes';

/**
 * It validates if the current route match with an application restricted route and if the current store state
 * has an imageUrl. If imageUrl is not presented, it will return true.
 * @param {Object} action action instance.
 * @param {Object} store store instance.
 * @param {String} routeRegex restricted path.
 * @returns {Boolean}
 */
const shouldRedirectToFallbackOnEmptyImageUrl = (store, action, routeRegex) => {
  let shouldRedirect = false;

  if (
    action.type === LOCATION_CHANGE &&
    action.payload &&
    action.payload.pathname &&
    action.payload.pathname.match(RegExp(routeRegex, 'i')) &&
    !store.getState().upload.imageUrl
  ) {
    shouldRedirect = true;
  }

  return shouldRedirect;
};

/**
 * This middleware intercepts the route change and validates the restricted routes and the imageUrl the user
 * has in the store.
 * @param {Object} store store instance.
 * @returns {(Object|Undefined)}
 */
const imageDataCheckRouteInterceptor = store => next => (action) => {
  const restrictedRoute = appConfiguration.getConfig().restrictedRoutes.imageUrl;
  let result;

  if (shouldRedirectToFallbackOnEmptyImageUrl(store, action, restrictedRoute.routeRegex)) {
    store.dispatch(push(appRoutes[restrictedRoute.fallback]));
  } else {
    result = next(action);
  }

  return result;
};

export default imageDataCheckRouteInterceptor;



// WEBPACK FOOTER //
// ./src/middlewares/ImageDataCheckRouteInterceptor.js